import { useMutation } from '@apollo/client';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { SvbrgChatMessageRole, SvbrgLanguage } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { Markdown } from '~/components/Markdown/Markdown';
import { useUser } from '~/hooks/useUser/useUser';
import { useChatSession } from '~/modules';
import { IntakeStepMessageInput } from '~/routes/IntakeDetail/components/IntakeMessageInput/IntakeStepMessageInput';

import { INTAKE_CHAT_REQUEST_MESSAGE_STEP_MUTATION } from './IntakeChatRequestMessageStep.mutation.gql';

export const IntakeChatRequestMessageStep = ({ message, role, createdBy, isCompleted }: ChatMessageProps) => {
  const { profile } = useUser({ userId: createdBy });
  const { t: tGlobal, i18n } = useTranslation(I18nNamespace.intake);
  const session = useChatSession();

  const { onError } = useCustomSnackbar();
  const [generate, { loading }] = useMutation(INTAKE_CHAT_REQUEST_MESSAGE_STEP_MUTATION, {
    onError,
  });
  const language = i18n.language === 'dx' ? SvbrgLanguage.DE : (i18n.language.toUpperCase() as SvbrgLanguage);
  if (role === SvbrgChatMessageRole.AI) {
    return (
      <ChatStep title={tGlobal('IntakeChatStep.assistant')} role={role} createdBy={createdBy} message={undefined}>
        <Markdown>{message ?? ''}</Markdown>
      </ChatStep>
    );
  }

  if (isCompleted) {
    return (
      <ChatStep
        role={role}
        createdBy={createdBy}
        title={`${profile?.firstName} ${profile?.lastName}`}
        message={undefined}
      >
        <Markdown>{message ?? ''}</Markdown>
      </ChatStep>
    );
  }

  return (
    <ChatStep
      role={role}
      createdBy={createdBy}
      title={`${profile?.firstName} ${profile?.lastName}`}
      message={undefined}
    >
      <IntakeStepMessageInput
        isLoading={loading}
        onSendMessage={(message) => {
          generate({
            variables: { data: { text: message, language, chatSessionId: session.id } },
          });
        }}
      />
    </ChatStep>
  );
};
